import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Message} from 'primereact/message';
import {Button} from 'primereact/button';
import {recruitmentApi} from '../recruitmentApi';

export const CandidateJournal = ({candidateId, kind, t}) => {
  const [data, setData] = useState({items: [], total_item_count: 0});
  const [page, setPage] = useState({first: 0, rows: 20});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => { setPage({first: 0, rows: 20}); }, [candidateId, kind]);
  useEffect(() => {
    let active = true;
    setLoading(true); setError(false);
    recruitmentApi('get', `/candidate/${candidateId}/journal/${kind}`, undefined, {page: Math.floor(page.first / page.rows) + 1, item_per_page: page.rows})
      .then(r => { if (active) setData(r.data.data); })
      .catch(() => { if (active) { setError(true); setData({items: [], total_item_count: 0}); } })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [candidateId, kind, page.first, page.rows, retry]);
  const date = value => value ? window.App.formatDateValue(value) : '—';
  const selection = row => row.recruitment_id ? <Link to={`/recruitment/recruitment/read/${row.recruitment_id}`}>{row.recruitment_name || `#${row.recruitment_id}`}</Link> : '—';
  return <div className="p-mt-3">
    {error && <div className="p-mb-3"><Message severity="error" text={t('candidateJournal.loadError')}/><Button className="p-button-text" label={t('candidateJournal.retry')} onClick={() => setRetry(value => value + 1)}/></div>}
    {kind === 'applications' && data.profile && <div className="p-grid p-mb-3">
      {['created_at', 'updated_at', 'last_modify', 'last_login'].map(field => <div className="p-col-12 p-md-6 p-xl-3" key={field}><div className="p-text-secondary p-mb-2">{t(`candidateJournal.${field}`)}</div><strong>{date(data.profile[field])}</strong></div>)}
    </div>}
    <DataTable value={data.items} dataKey="id" lazy paginator first={page.first} rows={page.rows} rowsPerPageOptions={[20, 50, 100]}
      totalRecords={data.total_item_count} onPage={e => setPage({first: e.first, rows: e.rows})} loading={loading}
      emptyMessage={t('noResults')} stripedRows responsiveLayout="scroll" autoLayout
      paginatorTemplate="RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink" currentPageReportTemplate="{first} - {last} / {totalRecords}">
      <Column field="admin_name" header={t('candidateJournal.admin')}/>
      <Column header={t('columnCreatedAt')} body={row => date(row.created_at)}/>
      {kind === 'activities' && <Column header={t('candidateJournal.eventDate')} body={row => date(row.date)}/>}
      <Column header={t('candidateJournal.selection')} body={selection}/>
      {kind === 'activities' ? [
        <Column key="event" field="event_name" header={t('candidateJournal.event')}/>,
        <Column key="status" field="status_name" header={t('candidateJournal.status')}/>,
        <Column key="rating" header={t('candidateJournal.rating')} body={row => row.rating ?? '—'}/>,
        <Column key="note" field="note" header={t('notes')} style={{maxWidth: '24rem', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere'}}/>,
        <Column key="details" body={row => row.event_id && row.recruitment_id ? <Link className="p-button p-button-text" to={`/recruitment/recruitment-event-candidate?recruitmentId=${row.recruitment_id}&eventId=${row.event_id}&eventScope=all`}>{t('candidateJournal.openEvent')}</Link> : null}/>,
      ] : [
        <Column key="source" header={t('candidateJournal.source')} body={row => t(`candidateJournal.sources.${row.source}`, {defaultValue: row.source || '—'})}/>,
        <Column key="ad" field="advertisement_name" header={t('candidateJournal.advertisement')}/>,
        <Column key="campaign" field="campaign_name" header={t('candidateJournal.campaign')}/>,
      ]}
    </DataTable>
  </div>;
};
export default withTranslation('common')(CandidateJournal);
